/**
 * Типы событий, генерируемых загружаемыми рекламными баннерами.
 */
export enum AdBannerEventType {
    adClosed = 'ad_closed',
    adFinish = 'ad_finish',
    adLoaded = 'ad_loaded',
    adStart = 'ad_start',
    mrgClosed = 'mrg-closed',
    mrgRenderInit = 'mrg-render-init',
    mrgShowed = 'mrg-showed',
    rbAdInfo = 'rb_ad_info',
    yaspEvent = 'yasp-event',
}
